import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AI_CHATBOT_STATUS } from '../../constants/aiChatbot';
import { ChevronIcon } from '../icons/ChevronIcon';
import { FrameIcon } from '../icons/FrameIcon';
import { MoreIcon } from '../icons/MoreIcon';
import styles from './AiChatbot.module.scss';
import AdditionalActionsPopup from '../../components/AiChatbot/ActionPopup';
import { adjustActionsPopupStatus, adjustAiChatbotStatus } from '../../store/actions/aiChatbot';

export function ActionsMenu() {
  const dispatch = useDispatch();
  const { actionsPopupStatus } = useSelector((state) => state.aiChatbot);

  const ref = useRef();

  const closeWidget = () => dispatch(adjustAiChatbotStatus(AI_CHATBOT_STATUS.OFF));
  const handleAdditionalActionsClick = (e) => {
    if (ref.current === e.target || e.target === ref.current.childNodes[0]) {
      const oppositeStatus =
        actionsPopupStatus === AI_CHATBOT_STATUS.OFF ? AI_CHATBOT_STATUS.ON : AI_CHATBOT_STATUS.OFF;

      dispatch(adjustActionsPopupStatus(oppositeStatus));
    }
  };

  return (
    <div className={styles.actionsMenuContainer}>
      <button className={styles.actionMenuItemContainer} onClick={handleAdditionalActionsClick} ref={ref}>
        <MoreIcon />
      </button>
      {actionsPopupStatus === AI_CHATBOT_STATUS.ON && <AdditionalActionsPopup />}
      <button className={styles.actionMenuItemContainer}>
        <FrameIcon />
      </button>
      <button className={styles.actionMenuItemContainer} onClick={closeWidget}>
        <ChevronIcon />
      </button>
    </div>
  );
}
